/**
 * Static-translations for hi. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const hi = {
  'anon.heading_default': 'अतिथि के रूप में जारी रखें',
  'anon.try_again': 'फिर से प्रयास करें',
  'auth.back_to_login': 'लॉगिन पर वापस जाएं',
  'auth.check_email_message': 'पुष्टि कोड के लिए अपना ईमेल देखें।',
  'auth.check_email_title': 'अपना ईमेल देखें',
  'auth.confirm_email_title': 'अपना ईमेल पुष्टि करें',
  'auth.confirmation_code': 'पुष्टि कोड',
  'auth.continue_with_apple': 'Apple से जारी रखें',
  'auth.continue_with_facebook': 'Facebook के साथ जारी रखें',
  'auth.continue_with_github': 'GitHub के साथ जारी रखें',
  'auth.continue_with_google': 'Google से जारी रखें',
  'auth.create_account': 'खाता बनाएँ',
  'auth.default_subtitle': 'सभी सुविधाओं तक पहुँचने और अपने डेटा को सिंक करने के लिए साइन इन करें।',
  'auth.email': 'ईमेल पता',
  'auth.email_already_registered': 'यह ईमेल पहले से पंजीकृत है। नीचे अपने पासवर्ड या जिस खाते से आपने साइन अप किया था, उससे साइन इन करें।',
  'auth.email_exists': 'इस ईमेल वाला खाता पहले से मौजूद है।',
  'auth.email_not_confirmed': 'कृपया पहले अपना ईमेल पुष्टि करें।',
  'auth.forgot_password': 'पासवर्ड भूल गए?',
  'auth.forgot_password_title': 'पासवर्ड भूल गए?',
  'auth.forgot_subtitle': 'अपना ईमेल दर्ज करें और हम आपको पासवर्ड रीसेट लिंक भेजेंगे।',
  'auth.generic_error': 'कुछ गलत हो गया',
  'auth.have_account': 'खाता है?',
  'auth.hide_password': 'पासवर्ड छुपाएँ',
  'auth.identity_already_linked': 'यह खाता पहले से पंजीकृत है। नीचे इससे साइन इन करें।',
  'auth.invalid_credentials': 'अमान्य ईमेल या पासवर्ड',
  'auth.invalid_otp': 'कोड अमान्य या समाप्त हो चुका है।',
  'auth.last_used': 'पिछली बार · {email}',
  'auth.last_used_no_email': 'पिछली बार',
  'auth.link_purchase_subheading': 'पहुँच बनाए रखने के लिए हम खरीदारी को आपके खाते से जोड़ेंगे।',
  'auth.log_in': 'लॉग इन',
  'auth.log_in_link': 'लॉग इन',
  'auth.login_continue_purchase': 'अपनी खरीदारी जारी रखने के लिए लॉग इन करें',
  'auth.network_error': 'नेटवर्क त्रुटि। अपना कनेक्शन जाँचकर पुनः प्रयास करें।',
  'auth.no_account': 'खाता नहीं है?',
  'auth.or': 'या',
  'auth.password': 'पासवर्ड',
  'auth.passwords_mismatch': 'पासवर्ड मेल नहीं खाते',
  'auth.rate_limited': 'बहुत अधिक अनुरोध। बाद में पुनः प्रयास करें।',
  'auth.repeat_password': 'पासवर्ड दोहराएँ',
  'auth.reset_link_valid': 'यह लिंक 1 घंटे के लिए मान्य है।',
  'auth.reset_password_title': 'पासवर्ड रीसेट करें',
  'auth.reset_sent_message': 'यदि वह ईमेल मौजूद है, तो रीसेट कोड भेज दिया गया है।',
  'auth.reset_sent_subtitle': 'हमने पासवर्ड रीसेट लिंक भेजा है। ईमेल में दिए निर्देशों का पालन करें।',
  'auth.restore_purchases_heading': 'खरीदारी पुनर्स्थापित करें',
  'auth.restore_purchases_subheading': 'कृपया अपनी खरीदारी पुनर्स्थापित करने के लिए साइन इन करें।',
  'auth.send_reset': 'रीसेट ईमेल भेजें',
  'auth.service_unavailable': 'सेवा अस्थायी रूप से अनुपलब्ध। बाद में पुनः प्रयास करें।',
  'auth.show_password': 'पासवर्ड दिखाएँ',
  'auth.sign_out': 'साइन आउट',
  'auth.sign_up': 'साइन अप',
  'auth.sign_up_link': 'साइन अप',
  'auth.signed_in': 'साइन इन',
  'auth.signin_failed': 'साइन-इन विफल',
  'auth.signup_failed': 'साइन-अप विफल',
  'auth.verify': 'सत्यापित करें',
  'auth.weak_password': 'पासवर्ड बहुत कमज़ोर है।',
  'auth.welcome': 'स्वागत है!',
  'auth.welcome_signup': 'स्वागत है!',
  'countdown.d': 'दि',
  'countdown.h': 'घं',
  'countdown.m': 'मि',
  'countdown.s': 'से',
  'cta.close': 'बंद करें',
  'cta.continue': 'जारी रखें',
  'cta.get_lifetime_access': 'आजीवन एक्सेस पाएँ',
  'cta.get_plan_daily': 'दैनिक प्लान चुनें',
  'cta.get_plan_monthly': 'मासिक प्लान चुनें',
  'cta.get_plan_weekly': 'साप्ताहिक प्लान चुनें',
  'cta.get_plan_yearly': 'वार्षिक प्लान चुनें',
  'cta.start_trial': '{days}-दिन का मुफ़्त ट्रायल शुरू करें',
  'modal.close_aria': 'बंद करें',
  'modal.continue': 'जारी रखें',
  'modal.error_generic': 'कुछ गलत हो गया',
  'modal.loading': 'लोड हो रहा है…',
  'modal.purchase_restored_subtitle': 'सब कुछ तैयार है — आनंद लें!',
  'modal.purchase_restored_title': 'वापसी पर स्वागत है',
  'modal.purchase_success_subtitle': 'सब कुछ तैयार है — आनंद लें!',
  'modal.purchase_success_title': 'भुगतान प्राप्त हुआ',
  'modal.verifying_subscription': 'आपकी सदस्यता जाँची जा रही है…',
  'nav.back': '← वापस',
  'nav.back_aria': 'वापस',
  'offer.limited_time': 'सीमित समय का ऑफर',
  'payment.awaiting_title': 'नए टैब में भुगतान पूरा करें',
  'payment.checking': 'जाँच रहे हैं…',
  'payment.ive_paid': 'मैंने भुगतान कर दिया',
  'payment.open_checkout_again': 'चेकआउट फिर से खोलें',
  'payment.open_checkout_button': 'चेकआउट खोलें',
  'pricing.free_trial_days': '{days}-दिन निःशुल्क परीक्षण',
  'pricing.included_per': 'प्रति शामिल {interval}:',
  'pricing.interval.day': 'दिन',
  'pricing.interval.lifetime_short': 'आजीवन',
  'pricing.interval.month': 'महीना',
  'pricing.interval.period': 'अवधि',
  'pricing.interval.week': 'सप्ताह',
  'pricing.interval.year': 'वर्ष',
  'pricing.money_back': '30 दिन की मनी-बैक गारंटी',
  'pricing.most_popular': 'सबसे लोकप्रिय',
  'pricing.no_prices': 'कोई मूल्य उपलब्ध नहीं।',
  'pricing.plan_label.daily': 'दैनिक प्लान',
  'pricing.plan_label.lifetime': 'आजीवन',
  'pricing.plan_label.monthly': 'मासिक प्लान',
  'pricing.plan_label.weekly': 'साप्ताहिक प्लान',
  'pricing.plan_label.yearly': 'वार्षिक प्लान',
  'pricing.plans_aria': 'योजनाएँ',
  'session.contact_support': 'सहायता से संपर्क करें',
  'session.restore_purchases': 'खरीदारी पुनर्स्थापित करें',
  'session.sign_out': 'साइन आउट',
  'session.signed_in_as_prefix': 'के रूप में साइन इन',
  'session.signing_out': 'साइन आउट हो रहा है…',
  'support.attachments_label': 'अटैचमेंट',
  'support.close_button': 'बंद करें',
  'support.done_button': 'पूरा',
  'support.email_placeholder': 'अपना ईमेल दर्ज करें',
  'support.heading': 'सहायता',
  'support.instruction': 'कृपया अपना सहायता अनुरोध सबमिट करने के लिए नीचे दिया गया फ़ॉर्म भरें।',
  'support.invalid_email': 'अमान्य ईमेल',
  'support.message_length': '1–5000 वर्ण',
  'support.message_placeholder': 'अपना संदेश दर्ज करें',
  'support.required': 'आवश्यक',
  'support.send_another': 'एक और अनुरोध भेजें',
  'support.send_button': 'भेजें',
  'support.sending': 'भेजा जा रहा है…',
  'support.subject_length': '3–200 वर्ण',
  'support.subject_placeholder': 'अपना विषय दर्ज करें',
  'support.success_heading': 'अनुरोध सबमिट किया गया',
  'support.success_message_prefix': 'हमें आपका संदेश मिल गया है और हम जवाब देंगे'
} as const;

export default hi;
